import { ASSET_PREFIX } from '~/constants/env'

const statusMap = {
  approving: {
    icon: `${ASSET_PREFIX}/images/ellipse.svg`,
    content: 'approving_pls_sign',
  },
  unApproving: {
    icon: `${ASSET_PREFIX}/images/ellipse.svg`,
    content: 'unApproving',
  },
  rejected: {
    icon: `${ASSET_PREFIX}/images/deny_slicing.svg`,
    content: 'rejected',
  },
  unApprove_rejected: {
    icon: `${ASSET_PREFIX}/images/deny_slicing.svg`,
    content: 'unApprove_rejected',
  },
  timeout: {
    icon: `${ASSET_PREFIX}/images/timeout_slicing`,
    content: 'timeout_pls_relaunch',
  },
  approve_success: {
    icon: `${ASSET_PREFIX}/images/success-checked.svg`,
    content: 'approve_success',
  },
  unApprove_success: {
    icon: `${ASSET_PREFIX}/images/success-checked.svg`,
    content: 'unApprove_success',
  },
}
export { statusMap }
